import template from './rw-terms-of-use.html';

export default {
  template,
  controller: 'RwTermsOfUseController',
};



// WEBPACK FOOTER //
// ./src/modules/utils/rw-terms-of-use/rw-terms-of-use-component.js